import { useState } from 'react';

import { scrollToTop } from '@/Utils/helpers';

export type TAlertMessage = {
  type: 'success' | 'error';
  title?: string;
  description: string;
};

export const useAlertMessage = (isScrolling = true) => {
  const [alertMessage, setAlertMessage] = useState<TAlertMessage | null>(null);

  const showAlert = (params: TAlertMessage) => {
    setTimeout(() => {
      if (!params) return;

      setAlertMessage({ ...params });
      setTimeout(() => setAlertMessage(null), 5000);
      if (isScrolling) {
        scrollToTop();
      }
    }, 500);
  };

  return { alertMessage, showAlert };
};

export const updatedSubscriptionAlertMessageOptions: TAlertMessage = {
  type: 'success',
  title: 'Subscription updated',
  description: 'Subscription was successfully updated.',
};
